export default __webpack_public_path__ + "static/textSummerization-8ad9582fea5caa1367f13ff06ef151e0.png";